// extracted by mini-css-extract-plugin
module.exports = {"container":"_f1348fb","icon":"_8e863e9"};